import React from 'react';
export default class Title extends React.Component {

  render() {
    return(
    <span className='dashboard-title'>{this.props.title}</span>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Title.jsx